<template>
    <div>
        <el-dialog title="司机时长统计" :visible.sync="show" :with-header="false" :before-close="closeDialog" width="80%" destroy-on-close>
            <div>
                <div style="font-size: 20px; font-weight: 700; margin-bottom: 20px">司机姓名:{{ driverName }}</div>
                <div class="handle-box-search">
                    <div class="handle-box">
                        <el-row class="head-search">
                            <el-col :span="12">
                                <span class="title">区间:</span>
                                <el-time-select
                                    placeholder="起始时间"
                                    v-model="search_data.start_time"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:60',
                                        end: '24:00'
                                    }"
                                    style="width: 200px"
                                >
                                </el-time-select>

                                <span>{{ textIsShow }}</span>
                                <el-time-select
                                    placeholder="结束时间"
                                    v-model="search_data.end_time"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:60',
                                        end: '24:00'
                                    }"
                                    style="width: 200px"
                                >
                                </el-time-select>
                            </el-col>

                            <el-col :span="12">
                                <span class="title">满足(小时):</span>

                                <el-input v-model="hours" placeholder="填写满足小时" class="handle-input mr10"></el-input>
                                <el-tooltip class="item" effect="dark" content="日期标红的为区间内不满足条件的数据" placement="right">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </div>

                    <el-button type="primary" icon="el-icon-search" @click="driverDetail">搜索</el-button>
                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                    <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport1" :disabled="progress_show"
                        >{{ progress_show ? '导出中...' : '导出' }}
                    </el-button>
                </div>
                <div style="font-weight:700;font-size:20px;margin-bottom:10px">
                    合计: {{total_duration}}
                </div>

                <el-table
                    :data="tableData"
            
                    :cell-style="cellStyle"
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                >
                    <el-table-column label="日期" prop="date" min-width="130"> </el-table-column>
                    <el-table-column label="在线时长" prop="online_duration"></el-table-column>
                    <el-table-column label="单量" prop="">* </el-table-column>
                    <el-table-column label="销单" prop="">* </el-table-column>
                    <el-table-column label="收入" prop="">* </el-table-column>
                    <el-table-column label="是否满足" prop="">
                        <template slot-scope="scope">
                            <el-tag :type="Number(scope.row.online_duration) < Number(hours) ? 'danger' : 'success'">
                                {{ Number(scope.row.online_duration) < Number(hours) ? '否' : '是' }}</el-tag
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: '',

        searchTime: {
            start_time: '',
            end_time: '',
            start_date: '',
            end_date: ''
        }
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            console.log(_this.data,'_this.data==');
            _this.driverName = _this.data.driver_name;
            _this.search_data.driver_code = _this.data.driver_code;
            _this.search_data.start_date = _this.searchTime.start_date;
            _this.search_data.end_date = _this.searchTime.end_date;
            _this.search_data.start_time = _this.searchTime.start_time;
            _this.search_data.end_time = _this.searchTime.end_time;

            _this.driverDetail();
        }
    },
    data() {
        return {
            total_duration: "",
            textTip: '',
            textVal: '',
            driverName: '',
            hours: '',

            progress_show: false,
            show: false,

            excelData: [],

            excelHead: [],

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                driver_code: '',
                start_date: '',
                end_date: '',
                start_time: '',
                end_time: ''
            }
        };
    },
    created() {
        _this = this;
    },
    computed: {
        textIsShow() {
            if (
                _this.search_data.end_time != '' &&
                _this.search_data.start_time != '' &&
                _this.search_data.end_time != null &&
                _this.search_data.start_time != null
            ) {
                console.log(_this.search_data.end_time, '_this.search_data.end_time');
                console.log(_this.search_data.start_time, '_this.search_data.start_time');

                if (_this.search_data.end_time.slice(0, 2) <= _this.search_data.start_time.slice(0, 2)) {
                    return '至次日';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    },

    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            // if(row.online_duration < _this.hours && columnIndex ===0) {
            if (row.online_duration < _this.hours) {
                return 'color:red;';
            }
        },

        toExport1() {
            _this.progress_show = true;
            _this.getExcelData();
        },
        getExcelData() {
            _this
                .$post('/driver_online/driverDetail', _this.search_data)
                .then((res) => {
                    if (this.$route.path == '/driverOnlineTime') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            _this.excelData.push({
                                name: _this.driverName,
                                date: res.data.list[i].date,
                                online_duration: res.data.list[i].online_duration
                            });
                        }

                        // 将数据导出execl
                        _this.exportData();

                        // 清空数据
                        _this.excelData = [];

                        _this.progress_show = false;
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            // const tHeader = ['日期', '在线时长', '单量', '销单', '收入','是否满足'];
            const tHeader = ['司机姓名', '日期', '在线时长'];
            const filterVal = ['name', 'date', 'online_duration'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '司机在线时长统计');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        driverDetail() {
            _this
                .$post('/driver_online/driverDetail', _this.search_data)
                .then((res) => {
                    _this.tableData = res.data.list;
                    _this.total_duration = res.data.total_duration;
                })
                .catch((err) => {});
        },

        // 批量下载
        toExport() {},

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.search_data = {
                driver_code: '',
                start_date: '',
                end_date: '',
                start_time: '',
                end_time: ''
            };
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
